import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ArticleService {
    constructor(private http: HttpClient) { }
    getAll(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/article/article?perPage=${perPage}&page=${page}&sort={"public_date":-1}&type=post`)
    }
    getDetail(id:string) {
        return this.http.get<any>(`${environment.apiUrl}/article/article/${id}`)
    }
    editPost(id:string, data:any) {
        return this.http.patch<any>(`${environment.apiUrl}/article/article/${id}`, data)
    }
    addPost(data:any) {
        return this.http.post<any>(`${environment.apiUrl}/article/article/`, data)
    }
    deletePost(id:string) {
        return this.http.delete<any>(`${environment.apiUrl}/article/article/${id}`)        
    }
    getComment(perPage:number, page:number, id:string) {
        return this.http.get<any>(`${environment.apiUrl}/article/comment?perPage=${perPage}&page=${page}&article=${id}`)
    }
    getCommentByParent(perPage:number, page:number, id:string) {
        return this.http.get<any>(`${environment.apiUrl}/article/comment?perPage=${perPage}&page=${page}&sort={"created_at":1}&parent=${id}`)
    }
    postComment(value:any) {
        return this.http.post<any>(`${environment.apiUrl}/article/comment`, value)
    }
    deleteComment(id:string) {
        return this.http.delete<any>(`${environment.apiUrl}/article/comment/${id}`)
    }
    getLike(id:string) {
        return this.http.get<any>(`${environment.apiUrl}/article/article-like?article=${id}`)        
    }
    postLike(value:any) {
        return this.http.post<any>(`${environment.apiUrl}/article/article-like`, value)        
    }
    deleteLike(id:string) {
        return this.http.delete<any>(`${environment.apiUrl}/article/article-like/${id}`)        
    }
    getLikeComment(id:string) {
        return this.http.get<any>(`${environment.apiUrl}/article/comment-like/${id}`)        
    }
    deleteLikeComment(id:string) {
        return this.http.delete<any>(`${environment.apiUrl}/article/comment-like/${id}`)        
    }
    postLikeComment(value:any) {
        return this.http.post<any>(`${environment.apiUrl}/article/comment-like`, value)        
    }
    postDislikeComment(value:any) {
        return this.http.post<any>(`${environment.apiUrl}/article/comment-dislike`, value)        
    }
    getAnnouncement(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/article/article?categories=61692a8b7c5f24094ff58399&perPage=${perPage}&page=${page}&sort={"public_date":-1}`)
    }
    getDocument(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/article/article?&type=document&perPage=${perPage}&page=${page}&sort={"created_at":-1}`)
    }
    searchDocument(perPage:number, page:number, searchQuery:any) {
        return this.http.get<any>(`${environment.apiUrl}/article/article?&type=document&perPage=${perPage}&page=${page}&${searchQuery}&sort={"created_at":-1}`,)
    }
    search(perPage:number, page:number, title:string) {
        return this.http.get<any>(`${environment.apiUrl}/article/article?perPage=${perPage}&page=${page}&title=${title}&sort={"public_date":-1}&type=post`)
    }

    getDocumentType(){
        return this.http.get<any>(`${environment.apiUrl}/article/type?sort={"created_at":-1}`)
    }

    getDocumentFolder(){
        return this.http.get<any>(`${environment.apiUrl}/article/folder?is_parent=true`)
    }

    getDocumentField(){
        return this.http.get<any>(`${environment.apiUrl}/article/field?sort={"created_at":-1}`)
    }

    getDocumentDepartment(){
        return this.http.get<any>(`${environment.apiUrl}/article/department?sort={"created_at":-1}`)
    }

    getPayslip(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/payslip/payslip?&perPage=${perPage}&page=${page}`)
    }

    getCategory(perPage:number, page:number){
        return this.http.get<any>(`${environment.apiUrl}/article/category?is_parent=true&perPage=${perPage}&page=${page}`)
    }

}